<template>
  <div>
    <div class="item-head">
      <span class="badge badge-pill badge-warning text-capitalize">{{ item.type }}</span>
      <span class="badge badge-pill badge-light">{{ item.id }}</span>
      <label class="mini-check"><input :id="`secure-${item.id}`" type="checkbox" v-model="item.security"> محافظت</label>
      <input type="text" class="form-control title-input" v-model="item.title" placeholder="عنوان">
      <b-icon
        v-for="score in maxScore"
        :key="score"
        :icon="score <= displayedScore ? 'star-fill' : 'star'"
        class="star-icon"
        :class="{ 'star-active': score <= displayedScore }"
        @mouseover="hoverScore = score"
        @mouseleave="hoverScore = 0"
        @click="previewScore = score"
      />
      <b-icon class="bg-danger p-1 rounded-pill text-white" icon="trash" @click="deleteQuestion()"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "StarInput",
  props: {
    item: {}
  },
  data() {
    return {
      previewScore: 0,
      hoverScore: 0,
    }
  },
  computed: {
    maxScore() {
      return 5
    },
    displayedScore() {
      return this.hoverScore || this.previewScore
    }
  },
  methods: {
    deleteQuestion() {
      this.$emit('removeQuestion')
    }
  }
}
</script>

<style scoped>
.item-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
.item-head .form-control:not(.title-input) {
  flex: 0 0 200px;
}
.mini-check {
  font-size: 12px;
  margin: 0;
}
.star-icon {
  font-size: 1.1rem;
  cursor: pointer;
  color: #d1d5db;
}
.star-active {
  color: #f5b301;
}
</style>
